// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1ULES","rootSmall":"AddTileButton_rootSmall__2HAcr"};